<template>
  <span :data-tourid="tourId">
    <v-text-field
      class="search-input-field body-2"
      clearable
      data-private
      dense
      hide-details
      outlined
      rounded
      :autofocus="autofocus"
      :background-color="backgroundColor"
      :class="{ 'search-input-clickable ': activeClickSearch }"
      :data-testid="testId || 'input-search'"
      :disabled="disabled"
      :placeholder="placeholder || $t('common.search')"
      :prepend-inner-icon="activeClickSearch ? null : 'mdi-magnify'"
      :value="value"
      @click:clear="$emit('clear')"
      @input="search"
    >
      <template v-slot:prepend-inner>
        <v-btn
          icon
          rounded
          small
          class="mt-0 pt-0"
          v-if="activeClickSearch"
          @click="handleClickSearch"
        >
          <v-icon size="20" color="blue-grey darken-1">
            mdi-magnify
          </v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </span>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SearchInput',

  props: {
    activeClickSearch: Boolean,
    autofocus: Boolean,
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    value: {
      type: String,
      required: false,
      default: '',
    },

    placeholder: {
      type: String,
      required: false,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    testId: {
      type: String,
      required: false,
    },

    tourId: {
      type: String,
      required: false,
    },
  },

  methods: {
    search: _.debounce(function(value) {
      this.$emit('change', value)
    }, 1000),

    handleClickSearch() {
      if (this.activeClickSearch) return this.$emit('clickSearchIcon')
    },
  },
}
</script>

<style lang="scss">
.search-input-clickable {
  .v-input__prepend-inner {
    margin-top: 4px !important;
    padding-top: 0 !important;
  }
}
.search-input-field {
  max-width: 500px;
  height: 36px;
  fieldset {
    border-color: $color-blue-grey-lighten1;
    height: 40px;
  }
  .v-input__control > .v-input__slot {
    padding: 0 16px;
    min-height: 36px !important;
  }
  .v-input__control,
  .v-text-field__slot {
    height: 36px;
  }
  .v-input__icon {
    height: 20px;
  }
  .v-progress-linear {
    width: 95%;
    margin-left: 2.5%;
  }
}
</style>
